import axios from 'axios';
import config from "../assets/json/texts.json";

const { STATIC_URL_DEV_EVENTOS, STATIC_URL_PROD_EVENTOS } = config;


// Instância para o Sistema de Eventos
const apiEventos = axios.create({
  baseURL: window.location.href.includes("localhost") || window.location.href.includes("10.5") ? STATIC_URL_DEV_EVENTOS : STATIC_URL_PROD_EVENTOS,
});

// Interceptor para injetar automaticamente o token do RH em cada chamada
apiEventos.interceptors.request.use((config) => {
  // Pega o token que o RH salvou no login
  const token = localStorage.getItem('token'); 
  
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default apiEventos;